import { Modal } from '@atom/mui';

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  statusLabel: string;
}

const WorkOrderRequiredFieldsConfirmModal = ({
  open,
  onCancel,
  onConfirm,
  statusLabel,
}: Props) => {
  return (
    <Modal
      open={open}
      cancelButtonText="Cancel"
      confirmButtonText="Proceed"
      onCancel={onCancel}
      onConfirm={onConfirm}
      title="Make Changes to Required Fields?"
      data-cy="workOrderRequiredFieldsConfirmModal"
      CancelButtonProps={{
        'data-cy': 'workOrderRequiredFieldsConfirmModalCancelButton',
      }}
      ConfirmButtonProps={{
        'data-cy': 'workOrderRequiredFieldsConfirmModalProceedButton',
      }}
    >
      {`The work status is “${statusLabel}”. Any changes made to required fields will move the work status back to “In Progress”. Do you want to proceed?`}
    </Modal>
  );
};

export default WorkOrderRequiredFieldsConfirmModal;
